import PageBackTitle from "../../Component/PageBackTitle";
import React, { useState, useEffect, useRef } from "react";
import "../AmcBOQ.css";
import { Link } from "react-router-dom";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import Snackbar from "@mui/material/Snackbar"; // Import Snackbar
import MuiAlert from "@mui/material/Alert";
import { HiOutlinePlus } from "react-icons/hi";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { IoSearchOutline } from "react-icons/io5";
import { MdExpandMore, MdExpandLess } from "react-icons/md";
import { TbRefresh } from "react-icons/tb";
import "../../Responsive/TableResponsive.css";
import Tooltip from "@mui/material/Tooltip";
import API_URL from "../../../src/Config";
import Pagination from "../../Component/Pagination";
import useClickOutside from "../../useClickOutside";

function AMCProjectTable({ isSidebarExpanded, projectID }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectAll, setSelectAll] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState(""); // New state for Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isDeletePopup, setIsDeletePopup] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const fetchTimeout = useRef(null);
  const [isSearching, setIsSearching] = useState(false);
  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [isPopupOpenedit, setisPopupOpenedit] = useState(false);
  const popupRef = useRef(null);

  const handleSort = (column) => {
    const order =
      sortColumn === column && sortOrder[column] === "asc" ? "desc" : "asc";

    setSortColumn(column);
    setSortOrder((prevOrder) => ({
      ...prevOrder,
      [column]: order,
    }));

    setIsSortPopup(false);

    const sortedschedules = [...projects].sort((a, b) => {
      const aValue = a[column]?.toString().toLowerCase() || "";
      const bValue = b[column]?.toString().toLowerCase() || "";

      if (aValue < bValue) return order === "asc" ? -1 : 1;
      if (aValue > bValue) return order === "asc" ? 1 : -1;
      return 0;
    });

    setProjects(sortedschedules);
  };

  const containerRef = useRef(null);
  const buttonRef = useRef(null);

  // const handleButtonClick = (index) => {
  //   setSelectedRowIndex(index === selectedRowIndex ? null : index);
  // };

  const handleIconClickedit = (index) => {
    setisPopupOpenedit(index === isPopupOpenedit ? null : index);
    // setSelectedRowIndex(false); // Reset row selection
    console.log("Popup toggled"); // Debugging
  };

  const handleClosePopup = () => {
    setIsSortPopup(false);
    setisPopupOpenedit(null);
  };

  useClickOutside([containerRef, buttonRef], handleClosePopup, 200); // 200ms delay
  useClickOutside([popupRef, buttonRef], handleClosePopup, 300);

  const handleDeletePopup = () => {
    setIsDeletePopup(!isDeletePopup);
  };

  const handleCancel = () => {
    setIsDeletePopup(false);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/get_amc_projects`, {
        headers: {
          Authorization: authKey,
        },
      });

      setProjects(response.data.Projects);
      setTotalItems(response.data.TotalItems);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching project data:", error.message);
      setLoading(false);
    }
  };

  const handleSearch = async (currentPage, itemsPerPage) => {
    if (!searchInput.trim()) {
      fetchData(currentPage, itemsPerPage);
      return;
    }

    try {
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(`${API_URL}/api/search_projects`, {
        headers: {
          Authorization: authKey,
          "Content-Type": "application/json",
        },
        params: {
          query: searchInput,
          page: currentPage,
          per_page: itemsPerPage,
        },
      });

      if (response.status === 200) {
        setProjects(response.data.Projects);
        setTotalItems(response.data.TotalItems);
      } else {
        console.error("Error fetching search results:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching search results:", error.message);
    } finally {
      setLoading(false);
      setIsSearching(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    clearTimeout(fetchTimeout.current);

    // Debounce API calls by 600ms
    fetchTimeout.current = setTimeout(() => {
      if (searchInput.trim() === "") {
        fetchData(page, itemsPerPage);
      } else {
        setIsSearching(true);
        handleSearch(page, itemsPerPage);
      }
    }, 600);

    return () => clearTimeout(fetchTimeout.current);
  }, [searchInput, page, itemsPerPage]);

  const handlePaginationChange = (currentPage, itemsPerPage) => {
    setPage(currentPage);
    setItemsPerPage(itemsPerPage);
    localStorage.setItem("currentPage", currentPage);
    localStorage.setItem("itemsPerPage", itemsPerPage);
  };

  useClickOutside([containerRef, buttonRef], () => setIsSortPopup(false));

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setSelectedRows(newSelectAll ? projects.map((project) => project.id) : []);
    setChecked(newSelectAll);
  };

  const handleSelectRow = (projectID) => {
    const updatedSelectedRows = selectedRows.includes(projectID)
      ? selectedRows.filter((id) => id !== projectID)
      : [...selectedRows, projectID];

    setSelectedRows(updatedSelectedRows);
    setSelectAll(updatedSelectedRows.length === projects.length);
    setChecked(updatedSelectedRows.length > 0);
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleArchiveProject = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/archive_projects`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey,
        },
        body: JSON.stringify({ ids: selectedRows }),
      });

      if (response.ok) {
        showSnackbar("Data archived successfully");
        const updatedProjects = projects.filter(
          (project) => !selectedRows.includes(project.ID)
        );
        setProjects(updatedProjects);
        fetchData();
        setSelectedRows([]);
        setSelectAll(false);
        setChecked(false);
      } else {
        console.error("Failed to delete projects");
      }
    } catch (error) {
      console.error("An error occurred while deleting projects:", error);
    }
  };

  const handleCloseButtonClick = () => {
    setChecked(false);
    setSelectedRows([]);
  };

  const handleSortpopup = () => {
    setIsSortPopup(!isSortPopup);
  };

  const handleArchiveDeparment = () => {
    navigate("/archive-project");
  };

  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleRefresh = () => {
    if (searchInput) {
      console.log("Search input is set:", searchInput);
    } else {
      fetchData(page, itemsPerPage);
    }
    setSearchInput("");
  };
  const closePopups = () => {
    setIsSortPopup(false);
    setIsDeletePopup(false);
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const formatter = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
    return formatter.format(date);
  };
  // const togglePopup = (projectID) => {
  //   setPopupUserID(projectID);
  //   setIsMainContainerVisible(true);
  // };

  const togglePopup = (projectID) => {
    // Instead of setting a local state, navigate to the specific
    // navigate(`/project-view/${projectID}`);
    navigate(`/project-view/${projectID}`, { state: { from: "amc" } });
  };

  const handleBoqConfugration = (projectID) => {
    navigate(`/boqs-form/${projectID}`);
  };

  const handleBoqDetailDynamic = (projectID, billing_frequency) => {
    navigate(`/boq-add-details/${projectID}/${billing_frequency}`);
  };

  const handleBoqReports = (projectID) => {
    navigate(`/boq-reports/${projectID}`);
  };
  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          {isChecked ? (
            <div className="action-header">
              <div className="action-header-content">
                <div className="action-header-content-leftside">
                  <div className="action-button">
                    <button className="delete" onClick={handleDeletePopup}>
                      Move to archive
                    </button>
                    {isDeletePopup && (
                      <div className="confirm-delete-popup">
                        <div className="confirm-delete-popup-content">
                          <div className="confirm-model">
                            <div className="confirm-model-content">
                              <div className="confirm-model-content-body">
                                <p>Are you sure want to move archive?</p>
                              </div>
                              <div className="confirm-model-content-footer">
                                <button
                                  className="confirm-delete-button"
                                  onClick={handleArchiveProject}
                                >
                                  Yes
                                </button>
                                <button
                                  className="confirm-cancel-button"
                                  onClick={handleCancel}
                                >
                                  No
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="action-header-content-rightside">
                  <button
                    className="action-header-close-button"
                    onClick={handleCloseButtonClick}
                  >
                    <IoCloseOutline className="action-header-close-icon" />
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="data-list-header">
              <div className="data-list-header-content">
                <PageBackTitle>All Projects</PageBackTitle>
                <div className="data-list-heading-content-right-side">
                  <div className="search-bar-container">
                    <input
                      type="text"
                      placeholder="Search..."
                      value={searchInput}
                      onChange={handleSearchInputChange}
                      className="search-bar"
                    />
                    <IoSearchOutline className="search-bar-icon" />
                  </div>

                  <Link to="/amc-projects-form" className="data-list-new">
                    <Tooltip title="New Project" arrow>
                      <button className="new-button">
                        <HiOutlinePlus className="new-plus-icon" /> New
                      </button>
                    </Tooltip>
                  </Link>

                  <Tooltip title="Refresh List" arrow>
                    <button className="refresh-button" onClick={handleRefresh}>
                      <TbRefresh className="refresh-icon" />
                    </button>
                  </Tooltip>
                  <button
                    className="sort-button"
                    onClick={handleSortpopup}
                    ref={buttonRef}
                  >
                    <PiDotsThreeOutlineVerticalFill className="sort-icon" />
                  </button>
                  {isSortPopup && (
                    <div className="sort-popup-container" ref={containerRef}>
                      <div className="sort-popup-content">
                        <div className="sort-by">
                          SORT BY{" "}
                          {sortOrder[sortColumn] === "asc"
                            ? "(Ascending)"
                            : "(Descending)"}
                        </div>
                        <div className="sort-by-button">
                          <button onClick={() => handleSort("project_name")}>
                            Project Name{" "}
                            {sortOrder.project_name === "asc" ? (
                              <MdExpandMore />
                            ) : (
                              <MdExpandLess />
                            )}
                          </button>{" "}
                          <br />
                          <button onClick={() => handleSort("customer_name")}>
                            Customer Name{" "}
                            {sortOrder.customer_name === "asc" ? (
                              <MdExpandMore />
                            ) : (
                              <MdExpandLess />
                            )}
                          </button>{" "}
                          <br />
                          <button onClick={() => handleSort("po_number")}>
                            PO Number{" "}
                            {sortOrder.po_number === "asc" ? (
                              <MdExpandMore />
                            ) : (
                              <MdExpandLess />
                            )}
                          </button>{" "}
                          <br />
                          <button onClick={() => handleSort("project_type")}>
                            Project Type{" "}
                            {sortOrder.project_type === "asc" ? (
                              <MdExpandMore />
                            ) : (
                              <MdExpandLess />
                            )}
                          </button>{" "}
                          <br />
                          <button onClick={() => handleSort("start_date")}>
                            Start Date{" "}
                            {sortOrder.start_date === "asc" ? (
                              <MdExpandMore />
                            ) : (
                              <MdExpandLess />
                            )}
                          </button>{" "}
                          <br />
                          <button onClick={() => handleSort("end_date")}>
                            End Date{" "}
                            {sortOrder.end_date === "asc" ? (
                              <MdExpandMore />
                            ) : (
                              <MdExpandLess />
                            )}
                          </button>{" "}
                          <br />
                          <button
                            onClick={() => handleSort("customer_location")}
                          >
                            Location{" "}
                            {sortOrder.customer_location === "asc" ? (
                              <MdExpandMore />
                            ) : (
                              <MdExpandLess />
                            )}
                          </button>{" "}
                        </div>
                        <button
                          className="delete-item"
                          onClick={handleArchiveDeparment}
                        >
                          Archived Project
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className="data-list-body" onClick={closePopups}>
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                    <div>Loading...</div>
                  </div>
                ) : projects.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th className="center-alignment">
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                          />
                        </th>
                        <th className="center-alignment">SR. NO.</th>
                        <th>PROJECT NAME</th>
                        <th className="center-alignment">CUSTOMER NAME</th>

                        <th>PO NUMBER</th>
                        <th className="center-alignment">PROJECT TYPE</th>
                        <th className="center-alignment">START DATE</th>
                        <th className="center-alignment">END DATE</th>
                        <th>LOCATION</th>
                        <th className="center-alignment">ACTION</th>

                        <th></th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {projects.map((project, index) => (
                        <tr key={project.id} className="hoverable-row">
                          <td className="center-alignment">
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(project.id)}
                              onChange={() => handleSelectRow(project.id)}
                            />
                          </td>

                          <td className="center-alignment">
                            {project.serial_no}
                          </td>
                          {/* <td>{project.project_name}</td> */}
                          <td
                            className="view-data"
                            onClick={() => togglePopup(project.id)}
                          >
                            {project.project_name || "NA"}
                          </td>
                          <td className="center-alignment">
                            {project.customer_name}
                          </td>

                          <td>{project.po_number}</td>

                          <td className="status-schedules center-alignment">
                            <div
                              style={{
                                backgroundColor:
                                  project.project_type === "Construction"
                                    ? "#6AAB9C"
                                    : project.project_type === "O & M"
                                    ? "#E06C78"
                                    : project.project_type === "Maintenance"
                                    ? "#384E78"
                                    : "transparent",
                                width: "8vw",
                              }}
                            >
                              {project.project_type || "NA"}
                            </div>
                          </td>

                          <td className="center-alignment">
                            {formatDate(project.start_date)}
                          </td>
                          <td className="center-alignment">
                            {formatDate(project.end_date)}
                          </td>
                          <td>{project.customer_location}</td>
                          <td className="center-alignment">
                            <div className="boq-action-button">
                              <button
                                className="boq-button"
                                onClick={() =>
                                  handleBoqConfugration(project.id)
                                }
                              >
                                Configuration BOQ
                              </button>

                                <button
                                  className="boq-button"
                                  onClick={() =>
                                    {handleBoqDetailDynamic(project.id, project.billing_frequency)}
                                  }
                                >
                                  BOQS
                                </button>

                              {/* {project.billing_frequency === "weekly" && (
                                <button
                                  className="boq-button"
                                  onClick={() =>
                                    handleBoqDetailWeek(project.id)
                                  }
                                >
                                  BOQS
                                </button>
                              )}

                              {project.billing_frequency === "monthly" && (
                                <button
                                  className="boq-button"
                                  onClick={() =>
                                    handleBoqDetailMonth(project.id)
                                  }
                                >
                                  BOQS
                                </button>
                              )} */}
                              <button
                                className="boq-button"
                                onClick={() => handleBoqReports(project.id)}
                              >
                                BOQ Reports
                              </button>
                            </div>
                          </td>

                          <td className="edit-pop">
                            <button
                              className="edit-data-button"
                              onClick={(event) =>
                                handleIconClickedit(index, event)
                              }
                            >
                              <div className="edit-button">
                                <MdExpandMore />
                              </div>
                            </button>
                          </td>
                          {isPopupOpenedit === index && (
                            <div className="edit-popup" ref={popupRef}>
                              <div className="edit-popup-contant">
                                <div className="edit-popup-button">
                                  <Link
                                    to={`/amc-projects-edit-form/${project.id}`}
                                    className="inquiry-new"
                                  >
                                    <button className="edit-button-inquiry">
                                      <MdOutlineModeEditOutline /> Edit
                                    </button>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">No Project Found</div>
                  </div>
                )}
              </div>
              <Pagination
                showPerPage={itemsPerPage}
                total={totalItems}
                onPaginationChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity="success">
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default AMCProjectTable;
